import React from 'react';

const FooterButtons = ( props ) => {
    
    return (
        <div className="modal-footer footer-alta-individuo">
            <button data-dismiss="modal" className="btn btn-secondary float-right" data-toggle="modal" onClick={()=>props.callback != undefined ? props.callback() : null } data-target="#datosIncorrectos">
                No
            </button >
            <button data-dismiss="modal" className="btn btn-cta float-right" onClick={/*INSERTAR METODO QUE PIDE DATOS PARA LA SOLICITUD Y CAMBIA LAS PROPS PARA EL REDIRECT*/() => {props.redirect() }}>
                Si
            </button>
        </div>
        )
}
export default FooterButtons;